import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import type { HourPoint } from '../../types/weather';
import { chartTheme } from './chartTheme';

export function HourlyPrecipChart({ hourly }: { hourly: HourPoint[] }) {
  const data = hourly.map(h => ({ time: h.timeLocal, Precip: h.precipPct }));
  const maxVal = Math.max(...data.map(d => d.Precip), 0);
  return (
    <div className="h-28 relative">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 6, right: 12, bottom: 0, left: 4 }}>
          <defs>
            <linearGradient id="precipFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#38bdf8" stopOpacity={0.85} />
              <stop offset="100%" stopColor="#38bdf8" stopOpacity={0.15} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="2 4" stroke={chartTheme.grid} vertical={false} />
          <XAxis dataKey="time" tick={chartTheme.tick} interval={3} stroke={chartTheme.grid} />
          <YAxis tick={chartTheme.tick} width={36} stroke={chartTheme.grid} domain={[0, 100]} tickFormatter={(v: number) => `${v}%`} />
          <Tooltip
            contentStyle={chartTheme.tooltip.contentStyle}
            labelStyle={chartTheme.tooltip.labelStyle}
            itemStyle={chartTheme.tooltip.itemStyle}
            formatter={(v) => `${Number(v)}%`}
          />
          <Area type="monotone" dataKey="Precip" stroke="#0ea5e9" strokeWidth={2} fill="url(#precipFill)" />
        </AreaChart>
      </ResponsiveContainer>
      {maxVal < 5 && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span className="text-[11px] text-slate-400 dark:text-slate-500 bg-slate-900/40 px-2 py-0.5 rounded">No measurable precipitation</span>
        </div>
      )}
    </div>
  );
}
